import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import makeStyles from "@material-ui/core/styles/makeStyles";
import 'video-react/dist/video-react.css';
import { Player, ControlBar, ClosedCaptionButton } from 'video-react';

const useStyles = makeStyles(() => ({
    modal: {
        overflowY: 'visible',
        '& .MuiDialog-paperFullWidth': {
            overflowY: 'visible',
        }
    },
    videoPlayer: {
        overflowY: 'visible',
        '& video': {
            overflowY: 'visible',
        },
    },
    modalContent: {
        padding: 0
    }
}));

const VideoModal = ({ open, handleClose }) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        className={classes.modal}
        fullWidth
        maxWidth="md"
      >
          <Player className={classes.videoPlayer}
                src='/videos/2019_Vince_STEM_Week_v06.mp4'
              autoPlay
              controls
            >
              <track
                  kind="captions"
                  lang="en-US"
                  label="English"
                  default
                  src="/videos/2019_Vince_STEM_Week.vtt"
              />
              <ControlBar autoHide={false}>
                  <ClosedCaptionButton order={7} />
              </ControlBar>
          </Player>

      </Dialog>
    </div>
  );
};

export default VideoModal;
